import React, { useEffect, useState } from 'react';
import './LivenessResultPage.css';

const LivenessResultPage = ({ isError, errorMessage, onContinue }) => {
  const [countdown, setCountdown] = useState(5);
  const hasRedirected = React.useRef(false);

  useEffect(() => {
    // Auto-scroll to hide address bar on mobile browsers
    const hideAddressBar = () => {
      setTimeout(() => {
        window.scrollTo(0, 1);
      }, 100);
    };
    hideAddressBar();
    window.addEventListener('orientationchange', hideAddressBar);
    
    setCountdown(5); // Reset countdown only on mount
    hasRedirected.current = false;
    
    return () => {
      window.removeEventListener('orientationchange', hideAddressBar);
    };
  }, []);

  useEffect(() => {
    if (countdown === 0 && !hasRedirected.current) {
      hasRedirected.current = true;
      onContinue();
      return;
    }
    if (countdown > 0) {
      const interval = setInterval(() => {
        setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [countdown, onContinue]);

  return (
    <div className="container liveness-result-container">
      <div>
        <div className="header">
          <div className="back-btn" onClick={() => window.history.back()}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M21 12C21 12.4142 20.6642 12.75 20.25 12.75H5.56031L11.0306 18.2194C11.3237 18.5124 11.3237 18.9876 11.0306 19.2806C10.7376 19.5737 10.2624 19.5737 9.96937 19.2806L3.21937 12.5306C3.07854 12.3899 2.99941 12.1991 2.99941 12C2.99941 11.8009 3.07854 11.6101 3.21937 11.4694L9.96937 4.71938C10.2624 4.42632 10.7376 4.42632 11.0306 4.71938C11.3237 5.01243 11.3237 5.48757 11.0306 5.78062L5.56031 11.25H20.25C20.6642 11.25 21 11.5858 21 12Z" fill="#121217"/>
            </svg>
          </div>
          <div className="headline">Digitale Ausweisüberprüfung</div>
          <div className="empty-space"></div>
        </div>
        <div className="content-section">
          <div className="checkmark-container">
            {isError ? (
              <svg width="194" height="194" viewBox="0 0 194 194" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="97" cy="97" r="92" fill="#E53935"/>
                <path d="M124 70L70 124" stroke="white" strokeWidth="9" strokeLinecap="round"/>
                <path d="M70 70L124 124" stroke="white" strokeWidth="9" strokeLinecap="round"/>
              </svg>
            ) : (
              <svg width="194" height="194" viewBox="0 0 194 194" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M97 189C147.81 189 189 147.81 189 97C189 46.1898 147.81 5 97 5C46.1898 5 5 46.1898 5 97C5 147.81 46.1898 189 97 189Z" fill="#2970CC"/>
                <path d="M69.4 97L87.8 115.4L124.6 78.6" fill="#2970CC"/>
                <path d="M69.4 97L87.8 115.4L124.6 78.6M189 97C189 147.81 147.81 189 97 189C46.1898 189 5 147.81 5 97C5 46.1898 46.1898 5 97 5C147.81 5 189 46.1898 189 97Z" stroke="white" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            )}
          </div>
          <div className="text-block">
            <h2>{isError ? 'Liveness-Check fehlgeschlagen' : 'Altersverifikation erfolgreich!'}</h2>
            <p>
              {isError
                ? (errorMessage || 'Die digitale Gesichtsüberprüfung war nicht erfolgreich. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support.')
                : 'Sie können am Automaten bezahlen oder Ihre gewünschten Produkte auswählen, um die Zahlung danach zu starten.'}
            </p>
            <p style={{ color: '#888', marginTop: 12, fontSize: 16 }}>
              {isError
                ? `Zurück zum Start in ${countdown} Sekunden...`
                : `Weiter in ${countdown} Sekunden...`}
            </p>
          </div>
        </div>
      </div>
      <div className="bottom-section">
        <button className="weiter-btn" onClick={onContinue}>
          {isError ? `Zurück (${countdown})` : `Weiter (${countdown})`}
        </button>
      </div>
    </div>
  );
};

export default LivenessResultPage;
